export const copyTextToClipboard = async (text: string) => {
  // The use of navigator.clipboard requires a secure origin.
  // So in development this won't work properly
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text)
  } else {
    window.prompt("Copy to clipboard: Ctrl+C, Enter", text)
  }
}
